import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { saveCard } from 'shared/createCard/thunks';
import { EEditStatus, TEditStatus } from 'shared/createCard/types/editStatus';

const initialState: TEditStatus = { status: EEditStatus.Init };

/* istanbul ignore next */
const editStatusSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(saveCard.pending, state => {
        state.status = EEditStatus.Preview;
      })
      .addCase(saveCard.fulfilled, state => {
        state.status = EEditStatus.Saved;
      })
      .addCase(saveCard.rejected, state => {
        state.status = EEditStatus.Failed;
      });
  },
  initialState,
  name: 'editStatus',
  reducers: {
    setStatus: (state, action: PayloadAction<EEditStatus>) => {
      state.status = action.payload;
    },
  },
});

export const {
  reducer: editStatusReducer,
  actions: { setStatus },
} = editStatusSlice;
